<div class="">
    <div class="container-fluid content-bg">
        <div class="card card-login mx-auto mt-5">
            <div class="card-header">Refer A Friend
                    <button type="button" class="close" data-dismiss="modal" (click)="referClose()" >&times;</button>
            </div>
            <div class="card-body">
                <form id="loginform">
                    <div class="form-group">
                        <div class="form-row">
                            <div class="col-md-6">
                                <label for="text">Your Name</label>
                                <input type="text" pattern="[a-zA-Z ]*" class="form-control" id="name" name="email"
                                    [(ngModel)]="ur_name">
                            </div>
                            <div class="col-md-6">
                                <label for="text">Referrals Name</label>
                                <input type="text" pattern="[a-zA-Z ]*" class="form-control" id="refname" name="refname"
                                    [(ngModel)]="referrals_name">
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="form-row">
                            <div class="col-md-6">
                                <label for="email">Referrals Email</label>
                                <input type="email" pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                                    class="form-control" id="email" name="email" ngModel #emailref="ngModel"
                                    [(ngModel)]="referrals_email" [ngModelOptions]="{standalone: true}">
                                <div *ngIf="emailref.errors &&(emailref.touched || emailref.dirty)"
                                    class="alert alert-danger">
                                    <div [hidden]="!emailref.errors?.pattern">
                                        Invalid pattern
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="mobile">Referrals Phone</label>
                                <input type="mobile" pattern="^((\\+91-?)|0)?[0-9]{10}$" minlength="10" maxlength="12"
                                    class="form-control" id="mobile" name="mobile" ngModel #mobileref="ngModel"
                                    [(ngModel)]="referrals_Phone" [ngModelOptions]="{standalone: true}">
                                <div *ngIf="mobileref.errors &&(mobileref.touched || mobileref.dirty)"
                                    class="alert alert-danger">
                                    <div [hidden]="!mobileref.errors?.pattern">
                                        Invalid Pattern
                                    </div>
                                    <div [hidden]="!mobileref.errors?.minlength">
                                        Number must be atleast 10 numbers
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="form-row">
                            <div class="col-md-12">
                                <label for="exampleInputEmail1">Comments &amp; Questions</label>
                                <textarea class="form-control" id="comment" name="comment"
                                    [(ngModel)]="referrals_comments"> </textarea>
                            </div>
                        </div>
                    </div>
                    <input type="submit" (click)="registerFunction()" class="btn btn-primary btn-block" value="Submit" />
                </form>
                <div class="text-center">
                    <a href="dashboard" class="d-block small">Back To Home</a>
                </div>
            </div>
        </div>
    </div>

    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">  
        <p style="color: white">Loading </p>  
        </ngx-spinner> 
</div>